import {
  AppstoreAddOutlined,
  AuditOutlined,
  BarChartOutlined,
  BookOutlined,
  CalculatorOutlined,
  CalendarOutlined,
  CheckSquareOutlined,
  ClusterOutlined,
  CreditCardOutlined,
  DashboardOutlined,
  DatabaseOutlined,
  DollarCircleOutlined,
  DollarOutlined,
  FileTextOutlined,
  FlagOutlined,
  HddOutlined,
  OrderedListOutlined,
  ReloadOutlined,
  RetweetOutlined,
  SettingOutlined,
  ShopOutlined,
  ShoppingOutlined,
  SlidersOutlined,
  SnippetsOutlined,
  TagOutlined,
  UserAddOutlined,
  VideoCameraOutlined
} from "@ant-design/icons";
import {
  FaRegBuilding,
  FaUserCog,
  FaUserGraduate,
  FaUsers
} from "react-icons/fa";
import { RiAdminFill, RiUserFill } from "react-icons/ri";
import { SiGoogleclassroom, SiGooglestreetview } from "react-icons/si";

import { BsBuilding } from "react-icons/bs";

// import { APP_PREFIX_PATH, AUTH_PREFIX_PATH } from "configs/AppConfig";

const franchiseeNavTree = [
    {
        key: "franchiseeTree",
        path: "",
        title: "Geral",
        icon: "",
        breadcrumb: false,
        submenu: [
            {
                key: "dashboard",
                path: "/dashboard/",
                title: "Dashboard",
                icon: DashboardOutlined,
                breadcrumb: false,
                submenu: [],
            },
            {
                key: "franchise-suport.index",
                path: "/suport/index",
                title: "Suporte",
                icon: DatabaseOutlined,
                breadcrumb: false,
                submenu: [
                  {
                    key: "service-calls.index",
                    path: "/suport/calls/index",
                    title: "Chamados",
                    icon: FileTextOutlined,
                    breadcrumb: false,
                    submenu: [
                      {
                        key: "service-calls.index",
                        path: "/suport/calls/index",
                        title: "Listar",
                        icon: OrderedListOutlined,
                        breadcrumb: false,
                        submenu: [],
                      },
                      {
                        key: "service-calls.store",
                        path: "/suport/calls/store",
                        title: "Criar",
                        icon: AppstoreAddOutlined,
                        breadcrumb: false,
                        submenu: [],
                      },
                      {
                        key: "franchise-suport.service-call-sectors.index",
                        path: "/suport/service-call-sectors/index",
                        title: "Departamentos",
                        icon: DatabaseOutlined,
                        breadcrumb: false,
                        submenu: [],
                      },
                    ],
                  },
                  {
                    key: "franchise-suport.areas.index",
                    path: "/suport/areas/index",
                    title: "Áreas",
                    icon: DatabaseOutlined,
                    breadcrumb: false,
                    submenu: [],
                  },
                ],
              },
            {
                key: "franchise-charge.index",
                path: "/franchise-charges/index",
                title: "Painel de Cobrança",
                icon: DollarOutlined,
                breadcrumb: false,
                submenu: [],
            },

            //       {
            //         key: "franchise-website.index",
            //         path: "/mywebsite",
            //         title: "Meu Site",
            //         icon: GlobalOutlined,
            //         breadcrumb: false,
            //         submenu: [
            //           {
            //             key: "franchise-website.login",
            //             path: "/mywebsite/login-page",
            //             title: "Página de Login",
            //             icon: UnlockOutlined,
            //             breadcrumb: false,
            //             submenu: [
            //
            //             ],
            //           },
            //           {
            //             key: "franchise-website.homepage",
            //             path: "/mywebsite/home-page",
            //             title: "Página Inicial",
            //             icon: HomeOutlined,
            //             breadcrumb: false,
            //             submenu: [
            //
            //             ],
            //           },
            //           {
            //             key: "blog",
            //             path: "/blog/",
            //             title: "Blog",
            //             icon: LaptopOutlined,
            //             breadcrumb: false,
            //             submenu: [
            //               {
            //                 key: "posts",
            //                 path: "/posts",
            //                 title: "Posts",
            //                 icon: LayoutOutlined,
            //                 breadcrumb: false,
            //                 submenu: [
            //                   {
            //                     key: "posts.index",
            //                     path: "/posts/index",
            //                     title: "Listar",
            //                     icon: OrderedListOutlined,
            //                     breadcrumb: false,
            //                     submenu: [],
            //                   },
            //                   {
            //                     key: "posts.store",
            //                     path: "/posts/store",
            //                     title: "Criar",
            //                     icon: AppstoreAddOutlined,
            //                     breadcrumb: false,
            //                     submenu: [],
            //                   },
            //                 ],
            //               },
            //               {
            //                 key: "post-categories",
            //                 path: "/post-categories/",
            //                 title: "Categorias",
            //                 icon: TagOutlined,
            //                 breadcrumb: false,
            //                 submenu: [
            //                   {
            //                     key: "post-categories.index",
            //                     path: "/post-categories/index",
            //                     title: "Listar",
            //                     icon: OrderedListOutlined,
            //                     breadcrumb: false,
            //                     submenu: [],
            //                   },
            //                   {
            //                     key: "post-categories.store",
            //                     path: "/post-categories/store",
            //                     title: "Criar",
            //                     icon: AppstoreAddOutlined,
            //                     breadcrumb: false,
            //                     submenu: [],
            //                   },
            //                 ],
            //               },
            //
            //             ],
            //           },
            //         ],
            //       },

            {
                // nota fiscal
                key: "invoices",
                path: "/invoices/",
                title: "Gestão de Notas Fiscais",
                icon: SnippetsOutlined,
                breadcrumb: false,
                submenu: [
                    {
                        key: "invoices.index",
                        path: "/invoices/index",
                        title: "Emitidas",
                        icon: SnippetsOutlined,
                        breadcrumb: false,
                        submenu: [
                            {
                                key: "nfse.index",
                                path: "/invoices/services/index",
                                title: "N.F de Serviço",
                                icon: OrderedListOutlined,
                                breadcrumb: false,
                                submenu: [],
                            },
                            {
                                key: "nfe.index",
                                path: "/invoices/products/index",
                                title: "N.F de Produto",
                                icon: OrderedListOutlined,
                                breadcrumb: false,
                                submenu: [],
                            },
                        ],
                    },
                    {
                        key: "invoices",
                        permissions: ["nfse.store", "nfe.store"],
                        path: "/invoices/store",
                        title: "Criar",
                        icon: AppstoreAddOutlined,
                        breadcrumb: false,
                        submenu: [],
                    },
                    {
                        key: "nfse.index",
                        path: "/invoices/config",
                        title: "Configurar",
                        icon: SettingOutlined,
                        breadcrumb: false,
                        submenu: [
                            {
                                key: "nfse.store",
                                path: "/invoices/config/my-data",
                                title: "Meus dados",
                                icon: UserAddOutlined,
                                breadcrumb: false,
                                submenu: [],
                            },
                            {
                                key: "nfse.update",
                                path: "/invoices/config/certificate",
                                title: "Certificado",
                                icon: FileTextOutlined,
                                breadcrumb: false,
                                submenu: [],
                            }
                        ],
                    },
                ],
            },

            {
                key: "marketing e Relacionamento",
                path: "/marketing/",
                title: "Marketing",
                icon: ShopOutlined,
                breadcrumb: false,
                submenu: [
                    {
                        key: "interested",
                        path: "/interesteds/",
                        title: "Interessados",
                        icon: ShoppingOutlined,
                        breadcrumb: false,
                        submenu: [
                            {
                                key: "interesteds.index",
                                path: "/interesteds/index",
                                title: "Listar",
                                icon: OrderedListOutlined,
                                breadcrumb: false,
                                submenu: [],
                            },
                            {
                                key: "interesteds.store",
                                path: "/interesteds/store",
                                title: "Cadastrar",
                                icon: AppstoreAddOutlined,
                                breadcrumb: false,
                                submenu: [],
                            },
                        ],
                    },
                    {
                        key: "follow-ups",
                        path: "/follow-ups",
                        title: "Follow Ups",
                        icon: BarChartOutlined,
                        breadcrumb: false,
                        submenu: [
                            {
                                key: "follow-ups.index",
                                path: "/follow-ups/index",
                                title: "Listar",
                                icon: OrderedListOutlined,
                                breadcrumb: false,
                                submenu: [],
                            },
                            {
                                key: "follow-ups.store",
                                path: "/follow-ups/store",
                                title: "Cadastrar",
                                icon: AppstoreAddOutlined,
                                breadcrumb: false,
                                submenu: [],
                            },
                        ],
                    },

                    {
                        key: "campaigns",
                        path: "/campaigns/",
                        title: "Campanha",
                        icon: FlagOutlined,
                        breadcrumb: false,
                        submenu: [
                            {
                                key: "campaigns.index",
                                path: "/campaigns/index",
                                title: "Listar",
                                icon: OrderedListOutlined,
                                breadcrumb: false,
                                submenu: [],
                            },
                            {
                                key: "campaigns.store",
                                path: "/campaigns/store",
                                title: "Criar Campanha",
                                icon: AppstoreAddOutlined,
                                breadcrumb: false,
                                submenu: [],
                            },
                        ],
                    },
                    {
                        key: "calendar",
                        path: "/calendar/",
                        title: "Calendário",
                        icon: CalendarOutlined,
                        breadcrumb: false,
                        submenu: [
                            {
                                key: "school-calendar.index",
                                path: "/school-calendar/index",
                                title: "Calendário Letivo",
                                icon: CalendarOutlined,
                                breadcrumb: false,
                                submenu: [],
                            },
                            {
                                key: "calendar-events",
                                path: "/calendar/",
                                title: "Eventos/Feriados",
                                icon: CalendarOutlined,
                                breadcrumb: false,
                                submenu: [
                                    {
                                        key: "calendar-events.index",
                                        path: "/calendar/index",
                                        title: "Listar",
                                        icon: OrderedListOutlined,
                                        breadcrumb: false,
                                        submenu: [],
                                    },
                                    {
                                        key: "calendar-events.store",
                                        path: "/calendar/store",
                                        title: "Criar",
                                        icon: AppstoreAddOutlined,
                                        breadcrumb: false,
                                        submenu: [],
                                    },
                                ],
                            },
                            // tipos de eventos
                            // {
                            //   key: "calendar-events-types",
                            //   path: "/event-types/",
                            //   title: "Tipos de Eventos",
                            //   icon: TagOutlined,
                            //   breadcrumb: false,
                            //   submenu: [
                            //     {
                            //       key: "calendar-events-types.index",
                            //       path: "/event-types/index",
                            //       title: "Listar",
                            //       icon: OrderedListOutlined,
                            //       breadcrumb: false,
                            //       submenu: [],
                            //     },
                            //     {
                            //       key: "calendar-events-types.store",
                            //       path: "/event-types/store",
                            //       title: "Criar",
                            //       icon: AppstoreAddOutlined,
                            //       breadcrumb: false,
                            //       submenu: [],
                            //     },
                            //   ],
                            // },
                        ],
                    },
                ],
            },

            {
                key: "phsycalspace",
                path: "/physical-space/",
                title: "Espaço Físico",
                icon: BsBuilding,
                breadcrumb: false,
                submenu: [
                    {
                        key: "buildings",
                        path: "/buildings/",
                        title: "Prédios",
                        icon: FaRegBuilding,
                        breadcrumb: false,
                        submenu: [
                            {
                                key: "buildings.index",
                                path: "/buildings/index",
                                title: "Listar",
                                icon: OrderedListOutlined,
                                breadcrumb: false,
                                submenu: [],
                            },
                            {
                                key: "buildings.store",
                                path: "/buildings/store",
                                title: "Cadastrar Prédio",
                                icon: AppstoreAddOutlined,
                                breadcrumb: false,
                                submenu: [],
                            },
                        ],
                    },
                    {
                        key: "building-floors",
                        path: "/building-floors/",
                        title: "Pavimentos",
                        icon: SiGooglestreetview,
                        breadcrumb: false,
                        submenu: [
                            {
                                key: "building-floors.index",
                                path: "/building-floors/index",
                                title: "Listar",
                                icon: OrderedListOutlined,
                                breadcrumb: false,
                                submenu: [],
                            },
                            {
                                key: "building-floors.store",
                                path: "/building-floors/store",
                                title: "Cadastrar Pavimento",
                                icon: AppstoreAddOutlined,
                                breadcrumb: false,
                                submenu: [],
                            },
                        ],
                    },
                    {
                        key: "rooms",
                        path: "/rooms/",
                        title: "Salas",
                        icon: SiGoogleclassroom,
                        breadcrumb: false,
                        submenu: [
                            {
                                key: "rooms.index",
                                path: "/rooms/index",
                                title: "Listar",
                                icon: OrderedListOutlined,
                                breadcrumb: false,
                                submenu: [],
                            },
                            {
                                key: "rooms.store",
                                path: "/rooms/store",
                                title: "Cadastrar Sala",
                                icon: AppstoreAddOutlined,
                                breadcrumb: false,
                                submenu: [],
                            },
                        ],
                    },
                ],
            },
            {
                key: "courses.index",
                path: "/courses/index",
                title: "Cursos",
                icon: VideoCameraOutlined,
                breadcrumb: false,
                submenu: [
                    {
                        key: "courses.index",
                        path: "/courses/index",
                        title: "Listagem de Cursos",
                        icon: OrderedListOutlined,
                        breadcrumb: false,
                        submenu: [],
                    },
                    {
                        key: "class-management",
                        path: "/class-management/",
                        title: "Gestão de aulas",
                        icon: CalendarOutlined,
                        breadcrumb: false,
                        submenu: [
                            {
                                key: "team-schedules.index",
                                path: "/team-schedule/",
                                title: "Agenda de aulas",
                                icon: CalendarOutlined,
                                breadcrumb: false,
                                submenu: [],
                            },
                            // tipos de eventos
                            // {
                            //   key: "any",
                            //   path: "/any/",
                            //   title: "Lançamento de Presença",
                            //   icon: TagOutlined,
                            //   breadcrumb: false,
                            //   submenu: [
                            //     {
                            //       key: "any.index",
                            //       path: "/event-types/index",
                            //       title: "Listar",
                            //       icon: OrderedListOutlined,
                            //       breadcrumb: false,
                            //       submenu: [],
                            //     },
                            //     {
                            //       key: "any.store",
                            //       path: "/any/store",
                            //       title: "Criar",
                            //       icon: AppstoreAddOutlined,
                            //       breadcrumb: false,
                            //       submenu: [],
                            //     },
                            //   ],
                            // },
                        ],
                    },
                    {
                        key: "evaluations",
                        path: "/evaluations/",
                        title: "Avaliações",
                        icon: CheckSquareOutlined,
                        breadcrumb: false,
                        submenu: [
                            {
                                key: "evaluations.index",
                                path: "/evaluation/index",
                                title: "Listar",
                                icon: OrderedListOutlined,
                                breadcrumb: false,
                                submenu: [],
                            },
                            {
                                key: "evaluation-methods",
                                path: "/evaluation-methods/",
                                title: "Métodos de Avaliação",
                                icon: AuditOutlined,
                                breadcrumb: false,
                                submenu: [
                                    {
                                        key: "evaluation-methods.index",
                                        path: "/evaluation-methods/index",
                                        title: "Listar",
                                        icon: OrderedListOutlined,
                                        breadcrumb: false,
                                        submenu: [],
                                    },
                                ],
                            },
                            {
                                key: "evaluation-types",
                                path: "/evaluation-types/",
                                title: "Tipos de Avaliação",
                                icon: BookOutlined,
                                breadcrumb: false,
                                submenu: [
                                    {
                                        key: "evaluation-types.index",
                                        path: "/evaluation-types/index",
                                        title: "Listar",
                                        icon: OrderedListOutlined,
                                        breadcrumb: false,
                                        submenu: [],
                                    },
                                ],
                            },
                            {
                                key: "evaluation-grades",
                                path: "/evaluation-grades/",
                                title: "Notas",
                                icon: CalculatorOutlined,
                                breadcrumb: false,
                                submenu: [
                                    {
                                        key: "evaluation-grades.index",
                                        path: "/evaluation-grades/index",
                                        title: "Listar",
                                        icon: OrderedListOutlined,
                                        breadcrumb: false,
                                        submenu: [],
                                    },
                                    {
                                        key: "evaluation-grades.store",
                                        path: "/evaluation-grades/store",
                                        title: "Lançar",
                                        icon: AppstoreAddOutlined,
                                        breadcrumb: false,
                                        submenu: [],
                                    },
                                ],
                            },
                        ],
                    },

                    //           {
                    //             key: "discount-management",
                    //             "path": "/discount-management/",
                    //             "title": "Desconto e Promoções",
                    //             "icon": PercentageOutlined,
                    //             "breadcrumb": false,
                    //             "submenu": [
                    //               {
                    //                 key: "scholarships",
                    //                 path: "/discount-management/scholarships/",
                    //                 title: "Bolsas",
                    //                 icon: ShoppingOutlined,
                    //                 breadcrumb: false,
                    //                 submenu: [
                    //                   {
                    //                     key: "scholarships.index",
                    //                     path: "/discount-management/scholarship/index",
                    //                     title: "Listar",
                    //                     icon: OrderedListOutlined,
                    //                     breadcrumb: false,
                    //                     submenu: [],
                    //                   },
                    //                   {
                    //                     key: "scholarships.store",
                    //                     path: "/discount-management/scholarship/store",
                    //                     title: "Criar",
                    //                     icon: AppstoreAddOutlined,
                    //                     breadcrumb: false,
                    //                     submenu: [],
                    //                   },
                    //                 ],
                    //               },
                    //
                    //             ]
                    //           },
                ],
            },
            {
                key: "products",
                path: "/products/",
                title: "Gestão de Produtos",
                icon: ShoppingOutlined,
                breadcrumb: false,
                submenu: [
                    {
                        key: "products.index",
                        path: "/products/index",
                        title: "Listar",
                        icon: OrderedListOutlined,
                        breadcrumb: false,
                        submenu: [],
                    },
                    // {
                    //   key: "ProductRequest",
                    //   path: "/products/request",
                    //   title: "Pedidos",
                    //   icon: ShoppingCartOutlined,
                    //   breadcrumb: false,
                    //   submenu: [],
                    // },
                    // {
                    //   key: "ProductDevolution",
                    //   path: "/products/devolution",
                    //   title: "Devoluções",
                    //   icon: RotateRightOutlined,
                    //   breadcrumb: false,
                    //   submenu: [],
                    // },
                    // {
                    //   key: "ProductCategory",
                    //   path: "/products/category/index",
                    //   title: "Categorias",
                    //   icon: TagOutlined,
                    //   breadcrumb: false,
                    //   submenu: [],
                    // },
                ],
            },

            {
                key: "configure-profiles",
                path: "/configure-profiles/",
                title: "Gestão de Usuários",
                icon: AuditOutlined,
                breadcrumb: false,
                submenu: [
                    {
                        key: "profile-managements",
                        path: "/profile-managements/",
                        title: "Gerenciar perfis",
                        icon: FaUserCog,
                        breadcrumb: false,
                        submenu: [
                            {
                                key: "profile-managements.index",
                                path: "/profile-management/index",
                                title: "Listar",
                                icon: OrderedListOutlined,
                                breadcrumb: false,
                                submenu: [],
                            },
                            // {
                            //   key: "profile-managements.store",
                            //   path: "/profile-management/store",
                            //   title: "Criar",
                            //   icon: AppstoreAddOutlined,
                            //   breadcrumb: false,
                            //   submenu: [],
                            // },
                        ],
                    },

                    {
                        key: "roles",
                        path: "/roles",
                        title: "Perfis e Permissões",
                        icon: UserAddOutlined,
                        breadcrumb: false,
                        submenu: [
                            {
                                key: "roles.index",
                                path: "/roles/index",
                                title: "Listar",
                                icon: OrderedListOutlined,
                                breadcrumb: false,
                                submenu: [],
                            },
                            {
                                key: "roles.store",
                                path: "/roles/store",
                                title: "Criar",
                                icon: AppstoreAddOutlined,
                                breadcrumb: false,
                                submenu: [],
                            },
                        ],
                    },
                    {
                        key: "users",
                        path: "/users/",
                        title: "Usuários",
                        icon: RiUserFill,
                        breadcrumb: false,
                        submenu: [
                            {
                                key: "users.index",
                                path: "/users/index",
                                title: "Listar",
                                icon: OrderedListOutlined,
                                breadcrumb: false,
                                submenu: [],
                            },
                            {
                                key: "users.store",
                                path: "/users/store",
                                title: "Criar",
                                icon: AppstoreAddOutlined,
                                breadcrumb: false,
                                submenu: [],
                            },
                        ],
                    },
                    {
                        key: "students",
                        path: "/students",
                        title: "Alunos",
                        icon: FaUserGraduate,
                        breadcrumb: false,
                        submenu: [
                            {
                                key: "students.index",
                                path: "/students/index",
                                title: "Listar",
                                icon: OrderedListOutlined,
                                breadcrumb: false,
                                submenu: [],
                            },
                            // {
                            //   key: "students.store",
                            //   path: "/enrollments/store",
                            //   title: "Criar",
                            //   icon: AppstoreAddOutlined,
                            //   breadcrumb: false,
                            //   submenu: [],
                            // },
                        ],
                    },

                    {
                        key: "teachers",
                        path: "/teachers/",
                        title: "Professores",
                        icon: RiUserFill,
                        breadcrumb: false,
                        submenu: [
                            {
                                key: "teachers.index",
                                path: "/teachers/index",
                                title: "Listar",
                                icon: OrderedListOutlined,
                                breadcrumb: false,
                                submenu: [],
                            },
                            // {
                            //   key: "teachers.store",
                            //   path: "/teachers/store",
                            //   title: "Criar",
                            //   icon: AppstoreAddOutlined,
                            //   breadcrumb: false,
                            //   submenu: [],
                            // },
                        ],
                    },
                ],
            },
            {
                key: "enrollments",
                path: "/enrollments/",
                title: "Matrículas",
                icon: FaUserGraduate,
                breadcrumb: false,
                submenu: [
                    {
                        key: "enrollments.index",
                        path: "/enrollments/index",
                        title: "Listar",
                        icon: OrderedListOutlined,
                        breadcrumb: false,
                        submenu: [],
                    },
                    {
                        key: "enrollments.store",
                        path: "/enrollments/store",
                        title: "Criar",
                        icon: AppstoreAddOutlined,
                        breadcrumb: false,
                        submenu: [],
                    },
                    {
                        key: "enrollments.renovation",
                        path: "/enrollments/renovation",
                        title: "Renovação de Matrícula",
                        icon: ReloadOutlined,
                        breadcrumb: false,
                        submenu: [],
                    },
                ],
            },
            {
                key: "teams",
                path: "/teams/",
                title: "Turmas",
                icon: FaUsers,
                breadcrumb: false,
                submenu: [
                    {
                        key: "teams.index",
                        path: "/teams/index",
                        title: "Listar",
                        icon: OrderedListOutlined,
                        breadcrumb: false,
                        submenu: [],
                    },
                    {
                        key: "teams.store",
                        path: "/teams/store",
                        title: "Criar",
                        icon: AppstoreAddOutlined,
                        breadcrumb: false,
                        submenu: [],
                    },
                ],
            },
            // {
            //   key: "team-schedules",
            //   path: "/team-schedules/",
            //   title: "Horário",
            //   icon: ClockCircleOutlined,
            //   breadcrumb: false,
            //   submenu: [
            //     {
            //       key: "team-schedulesList",
            //       path: "/team-schedules/index",
            //       title: "Listar",
            //       icon: OrderedListOutlined,
            //       breadcrumb: false,
            //       submenu: [],
            //     },
            //     {
            //       key: "team-schedulesCreate",
            //       path: "/team-schedules/store",
            //       title: "Criar",
            //       icon: AppstoreAddOutlined,
            //       breadcrumb: false,
            //       submenu: [],
            //     },
            //   ],
            // },
            {
                key: "accessProfile",
                path: "/access-profile/",
                title: "Perfil de Acesso",
                icon: RiAdminFill,
                breadcrumb: false,
                submenu: [
                    {
                        key: "accessProfileList",
                        path: "/access-profile/index",
                        title: "Listar",
                        icon: OrderedListOutlined,
                        breadcrumb: false,
                        submenu: [],
                    },
                    {
                        key: "accessProfileCreate",
                        path: "/access-profile/store",
                        title: "Criar",
                        icon: AppstoreAddOutlined,
                        breadcrumb: false,
                        submenu: [],
                    },
                ],
            },

            {
                key: "reports",
                path: "/reports/",
                title: "Relatórios",
                icon: CalendarOutlined,
                breadcrumb: false,
                submenu: [
                    {
                        key: "academic-reports",
                        path: "/reports/academic/",
                        title: "Acadêmico",
                        icon: TagOutlined,
                        breadcrumb: false,
                        submenu: [
                            {
                                key: "reports.analytical-attendance-list",
                                path: "/reports/academic/frequency",
                                title: "Frequência",
                                icon: OrderedListOutlined,
                                breadcrumb: false,
                                submenu: [],
                            },
                            {
                                key: "reports.attendance-by-team",
                                path: "/reports/academic/frequency-by-team",
                                title: "Frequência por Turma",
                                icon: OrderedListOutlined,
                                breadcrumb: false,
                                submenu: [],
                            },
                            {
                                key: "reports.enrollment-scholarships",
                                path: "/reports/academic/scholarships",
                                title: "Bolsistas",
                                icon: OrderedListOutlined,
                                breadcrumb: false,
                                submenu: [],
                            },
                            {
                                key: "reports.team",
                                path: "/reports/academic/teams",
                                title: "Gerencial de Turmas",
                                icon: OrderedListOutlined,
                                breadcrumb: false,
                                submenu: [],
                            },
                            {
                                key: "reports.analytical-teams",
                                path: "/reports/academic/analytical-teams",
                                title: "Analítico de Turmas",
                                icon: OrderedListOutlined,
                                breadcrumb: false,
                                submenu: [],
                            },
                            {
                                key: "reports.enrollment",
                                path: "/reports/academic/enrollment-analytics",
                                title: "Analítico de Matrículas",
                                icon: OrderedListOutlined,
                                breadcrumb: false,
                                submenu: [],
                            },
                            {
                                key: "reports.synthetical-enrollments",
                                path: "/reports/academic/synthetical-enrollments",
                                title: "Sintético de Matrículas",
                                icon: OrderedListOutlined,
                                breadcrumb: false,
                                submenu: [],
                            },
                            {
                                key: "reports.analytical-assessment",
                                path: "/reports/academic/evaluation-analytics",
                                title: "Analítico de Avaliações",
                                icon: OrderedListOutlined,
                                breadcrumb: false,
                                submenu: [],
                            },
                            {
                                key: "reports.grades",
                                path: "/reports/academic/grades",
                                title: "Notas",
                                icon: OrderedListOutlined,
                                breadcrumb: false,
                                submenu: [],
                            },
                        ],
                    },
                    //           {
                    //             key: "royalties-reports",
                    //             path: "/reports/royalties/",
                    //             title: "Royalties e Fundo de marca",
                    //             icon: TagOutlined,
                    //             breadcrumb: false,
                    //             submenu: [
                    //               {
                    //                 key: "reports.franchisor-royalties",
                    //                 path: "/reports/financial/franchisor-royalties",
                    //                 title: "Royalties",
                    //                 icon: OrderedListOutlined,
                    //                 breadcrumb: false,
                    //                 submenu: [],
                    //               },
                    //               // {
                    //               //   key: "reports.management-brand-funds",
                    //               //   path: "/reports/brand-funds/management-brand-funds",
                    //               //   title: "Gerencial de Fundo de Marca",
                    //               //   icon: OrderedListOutlined,
                    //               //   breadcrumb: false,
                    //               //   submenu: [],
                    //               // },
                    //               // {
                    //               //   key: "reports.analytical-enrollment",
                    //               //   path: "/reports/royalties/royalties-management",
                    //               //   title: "Gerencial de Royalties",
                    //               //   icon: OrderedListOutlined,
                    //               //   breadcrumb: false,
                    //               //   submenu: [],
                    //               // },
                    //               // {
                    //               //   key: "reports.analytical-sale",
                    //               //   path: "/reports/royalties/royalties-analytics",
                    //               //   title: "Analítico de Royalties",
                    //               //   icon: OrderedListOutlined,
                    //               //   breadcrumb: false,
                    //               //   submenu: [],
                    //               // },
                    //               // {
                    //               //   key: "reports.analytical-sale",
                    //               //   path: "/reports/royalties/invoice-management",
                    //               //   title: "Movimento de faturas de royalties",
                    //               //   icon: OrderedListOutlined,
                    //               //   breadcrumb: false,
                    //               //   submenu: [],
                    //               // },
                    //
                    //             ]
                    //           },
                    {
                        key: "sales-reports",
                        path: "/reports/sales/",
                        title: "Vendas",
                        icon: TagOutlined,
                        breadcrumb: false,
                        submenu: [
                            {
                                key: "reports.didactic-materials",
                                path: "/reports/sales/didactic-material",
                                title: "Materiais",
                                icon: OrderedListOutlined,
                                breadcrumb: false,
                                submenu: [],
                            },
                            {
                                key: "reports.analytical-enrollment",
                                path: "/reports/sales/index",
                                title: "Gerencial de Vendas",
                                icon: OrderedListOutlined,
                                breadcrumb: false,
                                submenu: [],
                            },
                            {
                                key: "reports.analytical-sale",
                                path: "/reports/sales/sales-analytics",
                                title: "Analítico de Vendas",
                                icon: OrderedListOutlined,
                                breadcrumb: false,
                                submenu: [],
                            },
                        ],
                    },
                    {
                        key: "financial-reports",
                        path: "/reports/financial/",
                        title: "Financeiro",
                        icon: TagOutlined,
                        breadcrumb: false,
                        submenu: [
                            {
                                key: "reports.franchisor-royalties",
                                path: "/reports/financial/franchisor-royalties",
                                title: "Royalties",
                                icon: OrderedListOutlined,
                                breadcrumb: false,
                                submenu: [],
                            },
                            {
                                key: "reports.negotiated-bills",
                                path: "/reports/financial/negotiated-bills",
                                title: "Migração Financeiro",
                                icon: OrderedListOutlined,
                                breadcrumb: false,
                                submenu: [],
                            },
                            {
                                key: "reports.cash-flow",
                                path: "/reports/financial/cash-flow",
                                title: "Fluxo Financeiro",
                                icon: OrderedListOutlined,
                                breadcrumb: false,
                                submenu: [],
                            },
                            {
                                key: "reports.financial-balance",
                                path: "/reports/financial/financial-balance",
                                title: "Balancete Financeiro",
                                icon: OrderedListOutlined,
                                breadcrumb: false,
                                submenu: [],
                            },
                            // {
                            //   key: "reports.financial-statement",
                            //   path: "/reports/financial/financial-statement",
                            //   title: "Extrato Financeiro",
                            //   icon: OrderedListOutlined,
                            //   breadcrumb: false,
                            //   submenu: [],
                            // },
                            {
                                key: "reports.invoice-statement",
                                path: "/reports/financial/invoice-statement",
                                title: "Extrato de Faturas",
                                icon: OrderedListOutlined,
                                breadcrumb: false,
                                submenu: [],
                            },
                            {
                                key: "reports.consolidated-receivables",
                                path: "/reports/financial/consolidated-receivables",
                                title: "Recebíveis Consolidados",
                                icon: OrderedListOutlined,
                                breadcrumb: false,
                                submenu: [],
                            },
                            {
                                key: "reports.withdraw-conciliation",
                                path: "/reports/financial/withdraw-conciliation",
                                title: "Conciliação de Saques",
                                icon: OrderedListOutlined,
                                breadcrumb: false,
                                submenu: [],
                            },
                            {
                                key: "reports.consolidated-statements",
                                path: "/reports/financial/consolidated-statement",
                                title: "Extrato Consolidado",
                                icon: OrderedListOutlined,
                                breadcrumb: false,
                                submenu: [],
                            },
                            {
                                key: "reports.analytical-receipt",
                                path: "/reports/financial/analytical-incomes",
                                title: "Analítico de Receitas",
                                icon: OrderedListOutlined,
                                breadcrumb: false,
                                submenu: [],
                            },
                            {
                                key: "reports.expected-payments",
                                path: "/reports/financial/expected-payments",
                                title: "Pagamentos Esperados",
                                icon: OrderedListOutlined,
                                breadcrumb: false,
                                submenu: [],
                            },
                            {
                                key: "financial-reports-synthetical-incomes",
                                path: "/reports/financial/synthetical-incomes",
                                title: "Sintético de Receitas",
                                icon: OrderedListOutlined,
                                breadcrumb: false,
                                submenu: [],
                            },
                            {
                                key: "reports.settled-consolidateds-statement",
                                path: "/reports/financial/settled",
                                title: "Consolidado de Liquidados",
                                icon: OrderedListOutlined,
                                breadcrumb: false,
                                submenu: [],
                            },
                            {
                                key: "reports.receipt",
                                path: "/reports/financial/revenue-manager",
                                title: "Gerencial de Receitas",
                                icon: OrderedListOutlined,
                                breadcrumb: false,
                                submenu: [],
                            },
                            {
                                key: "reports.defaulter",
                                path: "/reports/financial/defaulter",
                                title: "Inadimplência",
                                icon: OrderedListOutlined,
                                breadcrumb: false,
                                submenu: [],
                            },
                            {
                                key: "reports.bills-to-receive",
                                path: "/reports/financial/bills-receive",
                                title: "Contas a Receber no Período",
                                icon: OrderedListOutlined,
                                breadcrumb: false,
                                submenu: [],
                            },
                            {
                                key: "reports.forecast",
                                path: "/reports/financial/forecast",
                                title: "Forecast",
                                icon: OrderedListOutlined,
                                breadcrumb: false,
                                submenu: [],
                            },
                        ],
                    },
                    {
                        key: "access.reports",
                        path: "/reports/access/",
                        title: "Acesso",
                        icon: TagOutlined,
                        breadcrumb: false,
                        submenu: [
                            {
                                key: "reports.leads",
                                path: "/reports/access/leads",
                                title: "Leads",
                                icon: OrderedListOutlined,
                                breadcrumb: false,
                                submenu: [],
                            },
                            {
                                key: "reports.log-access",
                                path: "/reports/access/access-environment",
                                title: "Acessos ao Ambiente",
                                icon: OrderedListOutlined,
                                breadcrumb: false,
                                submenu: [],
                            },
                            {
                                key: "reports.manage-log-access",
                                path: "/reports/access/manage-access",
                                title: "Ger. de Acessos ao Ambiente",
                                icon: OrderedListOutlined,
                                breadcrumb: false,
                                submenu: [],
                            },
                        ],
                    },
                    {
                        key: "marketing",
                        path: "/reports/marketing/",
                        title: "Marketing",
                        icon: TagOutlined,
                        breadcrumb: false,
                        submenu: [
                            {
                                key: "reports.follow-up",
                                path: "/reports/marketing/follow-up",
                                title: "Follow up",
                                icon: OrderedListOutlined,
                                breadcrumb: false,
                                submenu: [],
                            },
                            {
                                key: "reports.newsletter-contact-form",
                                path: "/reports/marketing/newsletter",
                                title: "Newsletter/Formulario de contato",
                                icon: OrderedListOutlined,
                                breadcrumb: false,
                                submenu: [],
                            },
                            {
                                key: "reports.manage-campaigns",
                                path: "/reports/marketing/campaigns",
                                title: "Gerencial de Campanha",
                                icon: OrderedListOutlined,
                                breadcrumb: false,
                                submenu: [],
                            },
                            {
                                key: "reports.consultant",
                                path: "/reports/marketing/consultants",
                                title: "Consultores",
                                icon: OrderedListOutlined,
                                breadcrumb: false,
                                submenu: [],
                            },
                            {
                                key: "reports.birthday",
                                path: "/reports/marketing/birthdays",
                                title: "Aniversariantes",
                                icon: OrderedListOutlined,
                                breadcrumb: false,
                                submenu: [],
                            },
                        ],
                    },
                ],
            },

            {
                key: "configurations.index",
                path: "/configuration/",
                title: "Gestão financeira",
                icon: SettingOutlined,
                breadcrumb: false,
                submenu: [
                    //
                    //           {
                    //             key: "franchise-charges.index",
                    //             path: "/franchise-charges/index",
                    //             title: "Painel de Cobrança",
                    //             icon: DollarOutlined,
                    //             breadcrumb: false,
                    //             submenu: [],
                    //           },

                    {
                        key: "cash-flow.index",
                        path: "/cash-flow/index",
                        title: "Fluxo de Caixa",
                        icon: SlidersOutlined,
                        breadcrumb: false,
                        submenu: [],
                    },

                    {
                        key: "suppliers",
                        path: "/providers/",
                        title: "Fornecedores",
                        icon: HddOutlined,
                        breadcrumb: false,
                        submenu: [
                            {
                                key: "suppliers.index",
                                path: "/providers/index",
                                title: "Listar",
                                icon: OrderedListOutlined,
                                breadcrumb: false,
                                submenu: [],
                            },
                            {
                                key: "suppliers.store",
                                path: "/providers/store",
                                title: "Criar",
                                icon: AppstoreAddOutlined,
                                breadcrumb: false,
                                submenu: [],
                            },
                        ],
                    },

                    {
                        key: "bills-to-pay.index",
                        path: "/bills-to-pay/",
                        title: "Contas a pagar",
                        icon: FileTextOutlined,
                        breadcrumb: false,
                        submenu: [],
                    },

                    {
                        key: "accounts-payable.index",
                        path: "/bills-to-receive/",
                        title: "Contas a receber",
                        icon: FileTextOutlined,
                        breadcrumb: false,
                        submenu: [],
                    },

                    {
                        key: "bill-categories.index",
                        path: "/bill-categories/",
                        title: "Categorias",
                        icon: ClusterOutlined,
                        breadcrumb: false,
                        submenu: [],
                    },

                    {
                        key: "current-accounts.index",
                        path: "/current_accounts/index",
                        title: "Contas Corrente",
                        icon: CreditCardOutlined,
                        breadcrumb: false,
                        submenu: [],
                    },
                    {
                        key: "configurations.index",
                        path: "/configuration/index",
                        title: "Configurações",
                        icon: SettingOutlined,
                        breadcrumb: false,
                        submenu: [],
                    },
                    {
                        key: "bills-to-receive.index",
                        path: "/bills-receive/",
                        title: "Migração de financeiro",
                        icon: DollarCircleOutlined,
                        breadcrumb: false,
                        submenu: [
                            {
                                key: "",
                                path: "/bills-receive/",
                                title: "Migração",
                                icon: RetweetOutlined,
                                breadcrumb: false,
                                submenu: [
                                    {
                                        key: "bills-to-receive.import",
                                        path: "/bills-receive/migration",
                                        title: "Migrar",
                                        icon: AppstoreAddOutlined,
                                        breadcrumb: false,
                                        submenu: [],
                                    },
                                    {
                                        key: "bills-to-receive.index",
                                        path: "/bills-receive/registers",
                                        title: "Registros",
                                        icon: OrderedListOutlined,
                                        breadcrumb: false,
                                        submenu: [],
                                    },
                                ],
                            },
                        ],
                    },
                ],
            },
            // {
            //   key: "leave",
            //   path: "/leave",
            //   title: "Sair",
            //   icon: LogoutOutlined,
            //   breadcrumb: false,
            //   submenu: [],
            // },
        ],
    },
];

export default franchiseeNavTree;
